import React, { useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { useLocation, useNavigate } from "react-router-dom";
import AllStatus from "../../../authentication/AllStatus";
import Roles from "../../../authentication/Roles";
import { format } from "date-fns";
import DateRangePickerComponent from "../../../date/DateRangePickerComponent";

const UsersSearchComponent = () => {
  const [_] = useTranslation("global");
  const location = useLocation();
  const Navigate = useNavigate();
  const [state, setState] = useState({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  });
  const urlParams = new URLSearchParams(location.search);

  const [orderNumber, handleOrderNumber] = useState("");
  const [customerNumber, handleCustomerNumber] = useState("");
  const [productCode, handleProductCode] = useState("");
  const [sku, handleSku] = useState("");
  const [status, handleStatus] = useState("");
  const [startDate, handleStartDate] = useState("");
  const [endDate, handleEndDate] = useState("");

  const changeParam = () => {
    urlParams.set("name", orderNumber);
    urlParams.set("code", customerNumber);
    urlParams.set("email", productCode);
    urlParams.set("role", sku);
    urlParams.set("start_date", startDate);
    urlParams.set("end_date", endDate);
    urlParams.set("is_active", status);
    Navigate(`?${urlParams.toString()}`);
  };
  const resetHandler = () => {
    handleOrderNumber("");
    handleCustomerNumber("");
    handleProductCode("");
    handleSku("");
    handleStatus("");
    handleEndDate("");
    Navigate("");
  };

  const handleApply = (event, picker) => {
    const { startDate, endDate } = state.selection;
    const formattedStartDate = new Date(startDate.setHours(0, 0, 0, 0));
    const formattedEndDate = new Date(endDate.setHours(0, 0, 0, 0));

    const apiStartDate = format(formattedStartDate, "yyyy-MM-dd");
    const apiEndDate = format(formattedEndDate, "yyyy-MM-dd");
    // const startDate = picker.startDate.format("YYYY-MM-DD");
    // const endDate = picker.endDate.format("YYYY-MM-DD");
    handleStartDate(apiStartDate);
    handleEndDate(apiEndDate);
  };
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        changeParam();
      }}
    >
      <div className="w-100 d-flex flex-column gap-1">
        <div className="inputs-row d-flex w-100 gap-2 flex-column  flex-md-row">
          <Col>
            <Form.Group
              className="mb-3 flex-grow-1"
              controlId="exampleForm.ControlInput1"
            >
              <Form.Control
                type="text"
                placeholder={_("panel.name")}
                onChange={(e) => {
                  handleOrderNumber(e.target.value);
                }}
                value={orderNumber}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group
              className="mb-3 flex-grow-1"
              controlId="exampleForm.ControlInput1"
            >
              <Form.Control
                type="text"
                placeholder={_("panel.code")}
                onChange={(e) => {
                  handleCustomerNumber(e.target.value);
                }}
                value={customerNumber}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group
              className="mb-3 flex-grow-1"
              controlId="exampleForm.ControlInput1"
            >
              <Form.Control
                type="text"
                placeholder={_("panel.email")}
                onChange={(e) => {
                  handleProductCode(e.target.value);
                }}
                value={productCode}
              />
            </Form.Group>
          </Col>
        </div>
        <div className="inputs-row d-flex w-100 gap-2 justify-content-between flex-column  flex-md-row">
          <Col>
            <Form.Group className="" controlId="exampleForm.ControlInput1">
              <Form.Select
                onChange={(e) => {
                  handleSku(e.target.value);
                }}
                value={sku}
              >
                <option value={""} disabled>
                  المستخدم
                </option>
                {Object.values(Roles).map((status) => {
                  return (
                    <option selected={false} value={status.toLowerCase()}>
                      {_(`panel.${status.toLowerCase()}`)}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="">
              <Form.Select
                onChange={(e) => {
                  handleStatus(e.target.value);
                }}
                value={status}
              >
                <option value={""} disabled>
                  الحالة
                </option>
                <option value={1}>{_("panel.Active")}</option>
                <option value={0}>{_("panel.Inactive")}</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="" controlId="exampleForm.ControlInput1">
              <DateRangePickerComponent
                state={state}
                setState={setState}
                applyDateRange={() => handleApply()}
              />
              {/* <DateRangePicker onApply={handleApply}>
                <input type="text" className="form-control" />
              </DateRangePicker> */}
            </Form.Group>
          </Col>
        </div>

        <div className="action-inputs mt-3 d-flex justify-content-between">
          <input
            className=" px-5 align-self-end py-2"
            style={{
              backgroundColor: "rgb(243, 168, 55)",
              border: "none",
              borderRadius: "7px",
              color: "white",
              textAlign: "center",
            }}
            onClick={() => {
              changeParam();
            }}
            type="submit"
            value={_("panel.search")}
          />
          <Button
            style={{ backgroundColor: "rgb(23, 43, 77)" }}
            variant="dark"
            className="d-inline"
            onClick={resetHandler}
          >
            {_("panel.reset")}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default UsersSearchComponent;
